import { Grid } from "@material-ui/core";
import { StepTitle } from '../common/stepTitle';
import { RentalPortfolioStore } from "../../stores/rentalPortfolioStore";
import { PortfolioInformationForm } from "./portfolioInformationForm";

interface Props {
  store: RentalPortfolioStore;
}

export const PortfolioInformationStep = ({ store }: Props) => {
  return (
    <Grid container spacing={2}>
      <Grid item xs={12}>
        <StepTitle
          title={<>Portfolio Information</>}
          subtitle={
            <>
              Please fill out the following information for the property that
              will be used on the quote.
            </>
          }
        />
      </Grid>
      <Grid item xs={12}>
        <PortfolioInformationForm store={store} />
      </Grid>
    </Grid>
  );
};